import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import CarNotas from "../element/CarNotas";
import Menu from './Menu';
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
import DonutChart from "../element/charts/DonutChart";
import BarChart from "../element/charts/BarChart";
// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from '../helper/GetFetch';
import ShortData from '../helper/ShortData';
import loadMenu from '../js/main';
import Footer from './Footer';

// Color según la nota (escala 0-10)
export const colorNota = (nota) => {
  if (nota >= 7) return 'success';
  if (nota >= 6) return 'warning';
  return 'danger';
};

const Notas = () => {

  const history = useHistory();

  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem('dataUser');

  const [notas, setNotas] = useState({});
  const [solvencia, setSolvencia] = useState();
  const [cargando, setCargando] = useState(true);

  if (datos) {
    let cred = JSON.parse(datos);
    dataUser.token = cred.token;
    dataUser.nombre = cred.nombre;
    dataUser.carnet = cred.carnet;

  } else {
    history.push("/");
  }

  useEffect(() => {

    if (datos) {
      let cred = JSON.parse(datos);
      dataUser.token = cred.token;
      dataUser.nombre = cred.nombre;
      dataUser.carnet = cred.carnet;

      let notasMaterias = GetFetch.notas(dataUser.carnet, dataUser.token);
      notasMaterias.then((dataNotas) => {
        setNotas(ShortData.notasMaterias(dataNotas));
        setCargando(false);
        if(localStorage.getItem('solvencia')){
          setSolvencia('INSOLVENTE')
          setTimeout(() => {
            localStorage.removeItem('solvencia')
          }, 5000);
        }
      }).catch(() => setCargando(false));

      loadMenu();
    } else {
      history.push("/");
    }
  }, [datos, history, dataUser]);

  // Resumen para las visualizaciones
  const ciclos = notas.length > 0 ? notas : [];
  const todasLasNotas = ciclos.reduce((acc, c) => acc.concat(c.data || []), []);
  const promedioGeneral = todasLasNotas.length > 0
    ? todasLasNotas.reduce((s, n) => s + n.nota, 0) / todasLasNotas.length
    : 0;
  const promediosPorCiclo = ciclos.map((c) => {
    const datosCiclo = c.data || [];
    const prom = datosCiclo.length > 0
      ? datosCiclo.reduce((s, n) => s + n.nota, 0) / datosCiclo.length
      : 0;
    return { label: c.ciclo, value: +prom.toFixed(1) };
  });
  const aprobadas = todasLasNotas.filter((n) => n.nota >= 6).length;

  return (

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto
            foto={dataUser.carnet}
            alt="Foto alumno"
            tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Materias y notas por ciclo</h2>

        {solvencia ? (
          <div className="alert alert-danger" role="alert">
            <h4 className="mb-1">Estado: insolvente</h4>
            Para consultar tus notas debes estar solvente con la administración financiera.
          </div>
        ) : null}

        {cargando ? (
          <>
            <SkeletonCard rows={3} />
            <SkeletonCard rows={5} />
          </>
        ) : ciclos.length > 0 ? (
          <>
            {/* Panel de rendimiento */}
            <div className="card">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-12 col-md-4 text-center mb-4 mb-md-0">
                    <DonutChart
                      value={promedioGeneral}
                      max={10}
                      display={promedioGeneral.toFixed(1)}
                      caption="Promedio"
                      color={`var(--esen-${colorNota(promedioGeneral)})`}
                      size={150}
                      stroke={14}
                    />
                    <p className="text-muted mt-3 mb-0" style={{ fontSize: '0.85rem' }}>
                      {todasLasNotas.length} materias cursadas · {aprobadas} aprobadas
                    </p>
                  </div>
                  <div className="col-12 col-md-8">
                    <h5 className="mb-3" style={{ fontSize: '0.95rem' }}>Promedio por ciclo</h5>
                    <BarChart
                      data={promediosPorCiclo}
                      max={10}
                      height={160}
                      formatValue={(v) => v.toFixed(1)}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Detalle por ciclo */}
            {ciclos.map((element) => {
              return (
                <CarNotas
                  key={element.ciclo}
                  ciclo={element.ciclo}
                  datos={element.data} />
              )
            })}
          </>
        ) : (
          <EmptyState icon="fa-graduation-cap" title="Aún no hay notas registradas">
            Cuando Registro Académico publique tus calificaciones aparecerán aquí.
          </EmptyState>
        )}
      </div>
    </div>
  );
};

export default Notas;
